'use client';

import {useTranslations} from 'next-intl';
import {useState} from 'react';
import {Radio} from '../../../../../../components/design-system';
import useFilters from '../hooks/useFilters';
import FilterModal from './FilterModal';

type Sort =
  | 'rank:asc'
  | 'rank:desc'
  | 'name:asc'
  | 'name:desc'
  | 'price:asc'
  | 'price:desc';

export default function FilterSort() {
  const t = useTranslations('shop');
  const {filters, set} = useFilters();
  const [selected, setSelected] = useState<Sort | undefined>(filters.sort);

  function handleChange(sort?: Sort) {
    setSelected(sort);
  }

  function handleApply() {
    set({sort: selected});
  }

  return (
    <FilterModal label={t('filter.sort.title')} onApply={() => handleApply()}>
      <form className="tw-px-4 tw-space-y-2">
        <Radio
          name="sort"
          onChange={handleChange}
          selectedValue={selected}
          value="rank:asc"
          label={t('filter.sort.rankAsc')}
          reverse
        />
        <Radio
          name="sort"
          onChange={handleChange}
          selectedValue={selected}
          value="name:asc"
          label={t('filter.sort.nameAsc')}
          reverse
        />
        <Radio
          name="sort"
          onChange={handleChange}
          selectedValue={selected}
          value="price:asc"
          label={t('filter.sort.priceAsc')}
          reverse
        />
        <Radio
          name="sort"
          onChange={handleChange}
          selectedValue={selected}
          value="price:desc"
          label={t('filter.sort.priceDesc')}
          reverse
        />
      </form>
    </FilterModal>
  );
}
